import { render, staticRenderFns } from "./ComprobanteConsultar.vue?vue&type=template&id=6afb83f5&scoped=true&"
import script from "./ComprobanteConsultar.vue?vue&type=script&lang=js&"
export * from "./ComprobanteConsultar.vue?vue&type=script&lang=js&"
import style0 from "./ComprobanteConsultar.vue?vue&type=style&index=0&id=6afb83f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afb83f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VBtnToggle,VCard,VCol,VDatePicker,VIcon,VMenu,VRow,VSelect})
